








































































































import { mapState } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
import {UtilitiesFunctions} from "@/helpers";

@Component({
  computed: {
    ...mapState({
      dialogManager:(state: any) => state.app.dialogManager
    })
  }
})

export default class NewsletterDialog extends Vue {
  @Prop(String) private type!: string;
  title: string = "";
  checkbox: boolean = false;
  hidebox: boolean = false;
  email?: string = "";
  handleRoute = UtilitiesFunctions.handleRoute;
  on: any = {};

  created() {
  }

  closeDialog() {
    this.$store.dispatch("app/closeDialog");
  }

  resetCheckbox() {
    const email: any = document.getElementById("mce-EMAIL");
    setTimeout(() => {
      if (email) {
        // console.warn(email.getAttribute("value"));
        email.value = "";
        this.checkbox = false;
      }
    }, 1000);
  }

  checkHideBoxChange(checked: boolean) {
    if(checked) {
      localStorage.setItem("hideNewsletterDialog", "hidden");
    }
  }
}
